import * as XLSX from 'xlsx';

const DownloadAttendanceExcel = (attendanceData, companyName, setOpenBackdrop) => {
    // 1. Validate Data
    const dataList = Array.isArray(attendanceData) ? attendanceData : [];

    if (dataList.length === 0) {
        alert("No data found to export!");
        return;
    }

    setOpenBackdrop(true);

    try {
        // 2. Format Data for Excel (Mapping API keys to Readable Headers)
        const formattedData = dataList.map((item, index) => ({
            "S.No": index + 1,
            "Date": item.punch_date || 'N/A',
            "Employee Name": item.employee_name || 'N/A',
            "In Time": item.in_time ? item.in_time.split(' ')[1] : 'N/A',
            "Last Out Time": item.out_time ? item.out_time.split(' ')[1] : 'N/A',
            "Working Hours": item.working_hours || '00:00:00',
            "Last Site": item.site_name || 'N/A',
            "Status": item.last_punch_type || 'N/A'
        }));

        // 3. Create Worksheet
        const worksheet = XLSX.utils.json_to_sheet(formattedData);

        // 4. Set Column Widths (Optional but recommended)
        const wscols = [
            { wch: 6 },  // S.No
            { wch: 12 }, // Date
            { wch: 20 }, // Employee Name
            { wch: 12 }, // In Time
            { wch: 12 }, // Out Time
            { wch: 15 }, // Working Hours
            { wch: 20 }, // Site Name
            { wch: 10 }, // Status
        ];
        worksheet['!cols'] = wscols;

        // 5. Create Workbook and Append Worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Attendance Report");

        // 6. Generate Filename and Save
        const timestamp = new Date().toISOString().split('T')[0];
        const fileName = `${companyName.replace(/\s+/g, '_')}_Attendance_${timestamp}.xlsx`;
        
        XLSX.writeFile(workbook, fileName);

    } catch (error) {
        console.error("Excel Generation Error:", error);
        alert("Something went wrong while generating Excel file");
    } finally {
        setOpenBackdrop(false);
    }
};

export default DownloadAttendanceExcel;